import Tabbar from './Tabbar';

export default Tabbar;
